<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BookingCardMenu',
  mixins: [baseMixin],
  props: {
    disabled: {
      type: Boolean,
    },
  },
}
</script>

<template>
  <v-menu :disabled="disabled" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="booking-card-menu__activation-btn"
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        class="booking-card-menu__cancel-action-btn"
        @click="$emit('showCancelBookingDialog')"
      >
        <v-list-item-icon>
          <v-icon color="red" left>mdi-close</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="red--text">
            {{ $t('booking.cancelBookingBtn') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
